import React, { PureComponent } from 'react';
import CodeMirror from 'codemirror';
import 'codemirror/addon/comment/comment';
import 'codemirror/addon/dialog/dialog';
import 'codemirror/addon/edit/matchbrackets';
import 'codemirror/addon/edit/closebrackets';
import 'codemirror/addon/fold/brace-fold';
import 'codemirror/addon/fold/foldgutter';
import 'codemirror/addon/hint/show-hint';
import 'codemirror/addon/lint/lint';
import 'codemirror/keymap/sublime';
import 'codemirror-graphql/hint';
import 'codemirror-graphql/lint';
import 'codemirror-graphql/info';
import 'codemirror-graphql/jump';
import 'codemirror-graphql/mode';

import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/dracula.css';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/hint/show-hint.css';
import 'codemirror/addon/lint/lint.css';

const AUTO_COMPLETE_AFTER_KEY = /^[a-zA-Z0-9_@(]$/;

class QueryEditor extends PureComponent {
    constructor(props) {
        super();
        this.cachedValue = props.value || '';
    }

    componentDidMount() {
        this.editor = CodeMirror(this._node, {
            value: this.props.value || '',
            lineNumbers: true,
            tabSize: 2,
            foldGutter: {
                minFoldSize: 4,
            },
            keyMap: 'sublime',
            lint: {
                schema: this.props.schema,
            },
            hintOptions: {
                schema: this.props.schema,
                closeOnUnfocus: false,
                completeSingle: false,
            },
            info: {
                schema: this.props.schema,
                renderDescription: text => text, // TODO: Markdown?
                onClick: reference => this.props.onClickReference(reference),
            },
            jump: {
                schema: this.props.schema,
                onClick: reference => this.props.onClickReference(reference),
            },
            autoCloseBrackets: true,
            matchBrackets: true,
            showCursorWhenSelecting: true,
            mode: 'graphql',
            theme: 'dracula',
            gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
            extraKeys: {
                'Cmd-Space': () => this.editor.showHint({ completeSingle: true }),
                'Ctrl-Space': () => this.editor.showHint({ completeSingle: true }),
                'Alt-Space': () => this.editor.showHint({ completeSingle: true }),

                'Cmd-Enter': () => {
                    if (this.props.onRunQuery) {
                        this.props.onRunQuery();
                    }
                },
                'Ctrl-Enter': () => {
                    if (this.props.onRunQuery) {
                        this.props.onRunQuery();
                    }
                },
            }
        });

        this.editor.on('change', this._onEdit);
        this.editor.on('keyup', this._onKeyUp);
    }

    componentDidUpdate(prevProps) {
        if (this.props.schema !== prevProps.schema) {
            this.editor.options.lint.schema = this.props.schema;
            this.editor.options.hintOptions.schema = this.props.schema;
            this.editor.options.info.schema = this.props.schema;
            this.editor.options.jump.schema = this.props.schema;
            CodeMirror.signal(this.editor, 'change', this.editor);
        }
        if (this.props.value !== prevProps.value && this.props.value !== this.cachedValue) {
            this.editor.setValue(this.props.value);
        }
    }

    componentWillUnmount() {
        this.editor.off('change', this._onEdit);
        this.editor.off('keyup', this._onKeyUp);
        this.editor = null;
    }

    render() {
        return (
            <div className="query-editor" ref={node => {
                this._node = node;
            }}/>
        );
    }

    _onEdit = () => {
        // if (!this.ignoreChangeEvent) {
            this.cachedValue = this.editor.getValue();
            if (this.props.onEdit) {
                this.props.onEdit(this.editor.getValue());
            }
        // }
    };

    _onKeyUp = (cm, event) => {
        if (AUTO_COMPLETE_AFTER_KEY.test(event.key)) {
            this.editor.execCommand('autocomplete');
        }
    };
}

export default QueryEditor;



// WEBPACK FOOTER //
// ./src/components/QueryEditor.js